/* eslint-disable import/no-webpack-loader-syntax */
import React, { memo } from 'react';
import { ExporterComponent } from 'components/DesktopTable/types';
import { Campaign } from 'model/campaign';
import ExportToCsv from 'components/ExportToCsv';
import transformerWorkerUrl from 'worker-plugin/loader?name=mailMerges!../transformer';
import testingVar from 'utils/testingVar';
import { useWorker } from 'utils/useWorker';
import { captureException } from '@sentry/minimal';
import { MailMergesWorker } from '../transformer';
import { useStackDriverLogging } from '../../../../../data/context/StackDriverLogging';
import { getUserDataForLogging } from '../../../../../utils/logging';

const Exporter: ExporterComponent<Campaign[]> = ({ data, getData }) => {
  const { worker: transformer } = useWorker<MailMergesWorker>(
    transformerWorkerUrl,
    'MailMergesTransformer',
  );
  const { getUser, logToStackDriver } = useStackDriverLogging();
  const onDone = (input: any[]) => {
    // log to the stack driver unsubscribed emails
    try {
      const user = getUserDataForLogging(getUser());
      logToStackDriver({
        timestamp: Date.now(),
        user_id: user.user_id,
        user_installation_timestamp: user.user_installation_timestamp,
        plan: user.plan,
        is_biz_user: user.is_biz_user,
        domain: user.domain,
        event_type: 'csv_export',
        export_type: 'sent',
        message: 'User exported sent campaigns (csv_export)',
        list_of_merge_ids: input.map((d) => d.id),
      });
    } catch (e) {
      captureException(e);
    }
  };
  return (
    <ExportToCsv
      data-test-id={testingVar('submit-export')}
      data={data}
      getData={getData}
      transformer={transformer}
      fileName={`Exported_Mail_merges_${new Date().toDateString()}`}
      onDone={onDone}
    />
  );
};

export default memo(Exporter);
